import * as R from 'ramda';

const {CampaignDisplayType, CampaignGuidelineType} = R.path(['sn', 'enums'], window) || {};

export const isPinterestGuideline = R.pipe(
    R.prop('type'),
    R.test(/^pinterest_.*/)
);

export const getPinterestGuidelines = (type, defaultGuidelines) =>
    R.filter(R.propEq('type', type), defaultGuidelines);

export const getGuidelinesForCampaignDisplayType = (campaignDisplayType, defaultGuidelines) =>
    R.cond([
        [
            R.equals(CampaignDisplayType.PINTEREST_IMAGE),
            R.always(
                getPinterestGuidelines(CampaignGuidelineType.PINTEREST_IMAGE, defaultGuidelines)
            )
        ],
        [
            R.equals(CampaignDisplayType.PINTEREST_VIDEO),
            R.always(
                getPinterestGuidelines(CampaignGuidelineType.PINTEREST_VIDEO, defaultGuidelines)
            )
        ]
    ])(campaignDisplayType);

export const isDoGuideline = R.propEq('should', true);
export const isDoNotGuideline = R.propEq('should', false);



// WEBPACK FOOTER //
// ./common/guideline_helper.js